import React, { lazy } from "react";
import { BC_HQ } from "app_constants";
import { MenuIcon } from "components/icons/MenuIcon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";

import { BrandMenuPermission } from "navigation/permissions";
import { LD_FEATURE_FLAGS } from "types/context";
import type { ISectionProps } from "types/navigation";

const BRAND_MENUS: ISectionProps = {
  feature: "Brand Menus",
  icon: <MenuIcon />,
  path: "/brand-menus",
  level: ["brand", "store"],
  dateSupport: DateRangeSupport.NONE,
  requiresFeatureFlag: LD_FEATURE_FLAGS.brandMenuMvpBreadcrumb,
  subSections: [
    {
      feature: "Menus",
      app: BC_HQ,
      component: lazy(
        () =>
          import("containers/brand_menu/menus_list/menus_list_loader_wrapper")
      ),
      level: ["brand", "store"],
      scope: ["staff", "superuser"],
      path: "/brand-menus/menus",
      dateSupport: DateRangeSupport.NONE,
      verifyPermissions: BrandMenuPermission,
    },
    {
      feature: "New Menu",
      app: BC_HQ,
      component: lazy(
        () =>
          import("containers/brand_menu/menu_create/menu_create_loader_wrapper")
      ),
      hideInNav: true,
      level: ["brand", "store"],
      scope: ["staff", "superuser"],
      path: "/brand-menus/menu-create",
      dateSupport: DateRangeSupport.NONE,
      verifyPermissions: BrandMenuPermission,
    },
    {
      // - FIXME - display menu name in the header. see HQ-3936
      feature: "Edit Menu",
      app: BC_HQ,
      component: lazy(
        () => import("containers/brand_menu/menu_view/menu_view_loader_wrapper")
      ),
      hideInNav: true,
      level: ["brand", "store"],
      scope: ["staff", "superuser"],
      path: "/brand-menus/menu",
      dateSupport: DateRangeSupport.NONE,
      verifyPermissions: BrandMenuPermission,
    },
    {
      feature: "Items",
      app: BC_HQ,
      component: lazy(
        () =>
          import("containers/brand_menu/items_list/items_list_loader_wrapper")
      ),
      level: ["brand", "store"],
      scope: ["staff", "superuser"],
      path: "/brand-menus/items",
      dateSupport: DateRangeSupport.NONE,
      verifyPermissions: BrandMenuPermission,
    },
    {
      feature: "New Item",
      app: BC_HQ,
      component: lazy(
        () =>
          import("containers/brand_menu/item_create/item_create_loader_wrapper")
      ),
      hideInNav: true,
      level: ["brand", "store"],
      scope: ["staff", "superuser"],
      path: "/brand-menus/new-item",
      dateSupport: DateRangeSupport.NONE,
      verifyPermissions: BrandMenuPermission,
    },
    {
      feature: "Edit Item",
      app: BC_HQ,
      component: lazy(
        () => import("containers/brand_menu/item_edit/item_edit_loader_wrapper")
      ),
      hideInNav: true,
      level: ["brand", "store"],
      scope: ["staff", "superuser"],
      path: "/brand-menus/edit-item",
      dateSupport: DateRangeSupport.NONE,
      verifyPermissions: BrandMenuPermission,
    },
  ],
};

export default BRAND_MENUS;
